import React, { FC } from 'react';
import { ContentfulRichTextHTML } from 'components/ContentfulRichTextHTML';
import { Styled } from './';
import { ITeroRentalContractContentProps } from 'components/ITeroTermsConditionsModal/ITeroTermsConditionsModal.types';
import { isContractAvailableInCountry } from 'components/ITeroTermsConditionsModal/ITeroTermsConditionsModal.helper';
import { useI18n } from 'contexts/i18n';

// TODO: If you change the structure of contentful?.iTeroContract, make sure to update the related logic in ./ITeroContract to keep them in sync.
const ITeroRentalContract: FC<ITeroRentalContractContentProps> = ({
  doctorProfile,
  contentful,
  isLumina,
}) => {
  const isLuminaUS =
    isLumina &&
    isContractAvailableInCountry(
      doctorProfile?.country,
      contentful?.iTeroContract.luminaRentalTcUs.availableCountries
    );
  const isLuminaCA =
    isLumina &&
    isContractAvailableInCountry(
      doctorProfile?.country,
      contentful?.iTeroContract.luminaRentalTcCa.availableCountries
    );
  const isRentalTCUS =
    !isLumina &&
    isContractAvailableInCountry(
      doctorProfile?.country,
      contentful?.iTeroContract.rentalTcUs.availableCountries
    );
  const isRentalTCCA =
    !isLumina &&
    isContractAvailableInCountry(
      doctorProfile?.country,
      contentful?.iTeroContract.rentalTcCa.availableCountries
    );
  const i18n = useI18n();
  
  return (
    <>
      <div>
        <Styled.Title>
          {i18n['ITERO RENTAL TERMS AND CONDITIONS'] ??
            'ITERO RENTAL TERMS AND CONDITIONS'}
        </Styled.Title>
      </div>
      {isLuminaUS && (
        <ContentfulRichTextHTML
          document={contentful?.iTeroContract.luminaRentalTcUs.content}
        />
      )}
      {isLuminaCA && (
        <ContentfulRichTextHTML
          document={contentful?.iTeroContract.luminaRentalTcCa.content}
        />
      )}
      {isRentalTCUS && (
        <ContentfulRichTextHTML
          document={contentful?.iTeroContract.rentalTcUs.content}
        />
      )}
      {isRentalTCCA && (
        <ContentfulRichTextHTML
          document={contentful?.iTeroContract.rentalTcCa.content}
        />
      )}

      {isContractAvailableInCountry(
        doctorProfile?.country,
        contentful?.iTeroContract.californiaDeclaration.availableCountries
      ) && (
        <p style={{ border: '5px solid black', padding: 10 }}>
          <ContentfulRichTextHTML
            document={contentful?.iTeroContract.californiaDeclaration.content}
          />
        </p>
      )}
    </>
  );
};

export default ITeroRentalContract;
